import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { RequestWithdrowal } from "../../apis/api/DirectoryApi";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import PaymentAnimation from "./PaymentAnimation";
import "./BusinessImpact.css";

const WithdrawalForm = () => {
  const { register, handleSubmit, formState:{ errors }, reset } = useForm();
  const dispatch   = useDispatch();
  const company_id = Cookies.get("company_id");

  const onSubmit = async (data) => {
    const res = await dispatch(RequestWithdrowal({ ...data, company_id }));
    if (res?.payload?.status === "success") {
      toast.success("Withdrawal request submitted successfully.");
      reset();
    } else {
      toast.error(res?.payload?.message || "Something went wrong.");
    }
  };

  return (
    <motion.div className="bi-page"
      initial={{ opacity:0, y:16 }} animate={{ opacity:1, y:0 }}
      transition={{ duration:.4, ease:[.22,.68,0,1.2] }}>

      {/* header */}
      <div className="bi-page-header">
        <div>
          <h1 className="bi-page-title">Withdrawal Request</h1>
          <p className="bi-page-sub">Submit a withdrawal request to the admin for approval.</p>
        </div>
        <span className="bi-header-badge">
          <i className="bx bx-money-withdraw"></i> Withdrawal
        </span>
      </div>

      {/* layout */}
      <div className="bi-layout">

        {/* form */}
        <motion.div className="bi-form-card"
          initial={{ opacity:0, x:-14 }} animate={{ opacity:1, x:0 }}
          transition={{ duration:.35 }}>

          <form onSubmit={handleSubmit(onSubmit)}>

            {/* Amount */}
            <div className="bi-field">
              <label className="bi-label">Amount <span>*</span></label>
              <div className="bi-input-prefix">
                <span className="bi-prefix">$</span>
                <input type="number" placeholder="0.00"
                  className={`bi-input bi-input-with-prefix ${errors.amount?"error":""}`}
                  {...register("amount",{ required:"Amount is required", min:{ value:1, message:"Min $1" } })} />
              </div>
              {errors.amount && <span className="bi-error">{errors.amount.message}</span>}
            </div>

            {/* Password */}
            <div className="bi-field">
              <label className="bi-label">Password <span>*</span></label>
              <input type="password" autoComplete="new-password"
                placeholder="Enter your password"
                className={`bi-input ${errors.pay_password?"error":""}`}
                {...register("pay_password",{ required:"Password is required", minLength:{ value:6, message:"Min 6 characters" } })} />
              {errors.pay_password && <span className="bi-error">{errors.pay_password.message}</span>}
            </div>

            {/* Comment */}
            <div className="bi-field">
              <label className="bi-label">Comment <span>*</span></label>
              <textarea rows={4} placeholder="Reason for withdrawal…"
                className={`bi-input ${errors.comment?"error":""}`}
                {...register("comment",{ required:"Comment is required", minLength:{ value:5, message:"Min 5 characters" } })} />
              {errors.comment && <span className="bi-error">{errors.comment.message}</span>}
            </div>

            {/* info note */}
            <div className="bi-note">
              <i className="bx bx-info-circle"></i>
              Your request will be reviewed by the admin before processing.
            </div>

            <button type="submit" className="bi-submit">
              <i className="bx bx-check-circle"></i> Submit Withdrawal Request
            </button>
          </form>
        </motion.div>

        {/* animation panel */}
        <div className="bi-anim-panel">
          <PaymentAnimation mode="withdrawal" />
        </div>

      </div>
    </motion.div>
  );
};

export default WithdrawalForm;
